import { render, staticRenderFns } from "./ModalAddHouse.vue?vue&type=template&id=8c184ea4&scoped=true&"
import script from "./ModalAddHouse.vue?vue&type=script&lang=js&"
export * from "./ModalAddHouse.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddHouse.vue?vue&type=style&index=0&id=8c184ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c184ea4",
  null
  
)

export default component.exports